import {Component, OnInit} from '@angular/core';
import {
  fadeInLeftOnEnterAnimation,
  fadeInOnEnterAnimation,
  fadeOutOnLeaveAnimation,
  fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {DomSanitizer} from '@angular/platform-browser';
import {UserService} from '../../../services/user.service';
import {DelegateModel} from '../../team/models/delegate.model';
import {ActivatedRoute} from '@angular/router';
import {NavService} from '../../../services/nav.service';
import {JourneyService} from '../../journey/service/journey.service';
import {TasksModel} from '../../tasks/models/tasks.model';

@Component({
  selector: 'calls-aicoach-page',
  templateUrl: './calls-aicoach.page.html',
  styleUrls: ['./calls-aicoach.page.scss'],
  animations: [
    fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
    fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
    fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
    fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
  ]
})

export class CallsAicoachPage implements OnInit {
  url = null;
  delegate: DelegateModel = null;

  task: TasksModel = null;
  aicoach_id: number = null;

  retries: number = 0;

  constructor(
    public sanitizer: DomSanitizer,
    public userService: UserService,
    private activatedRoute: ActivatedRoute,
    private nav: NavService,
    private journeyService: JourneyService,
  ) {
    const task_id = parseInt(this.activatedRoute.snapshot.paramMap.get('task_id'), 10) || 0;
    const aicoach_id = parseInt(this.activatedRoute.snapshot.paramMap.get('aicoach_id'), 10) || 0;

    console.log('task_id', task_id);
    console.log('aicoach_id', aicoach_id);

    if (!task_id || aicoach_id < 1) {
      this.nav.navigateHome();
      return;
    }

    this.journeyService.getMyTask(task_id).then(task => {
      if (!task) {
        this.nav.navigateHome();
        return;
      }
      this.task = task;

      this.initAICoach();
    })

    this.aicoach_id = aicoach_id - 1;
  }

  ngOnInit() {
  }

  initAICoach() {
    if (!this.task.details.aicoach
      || this.task.details.aicoach.length < this.aicoach_id
      || !this.task.details.aicoach[this.aicoach_id].url) {
      this.nav.navigateHome();
      return;
    }

    const url = this.task.details.aicoach[this.aicoach_id].url;

    this.retries = 0;
    this.initMagicLink(url);
  }

  initMagicLink(url) {
    ++this.retries;
    console.log(`initMagicLink [attempt #${this.retries}]`, url);
    this.userService.getMyHBMagicLink(url).then((res) => {
      if (res && res.url !== url) {
        console.log('initMagicLink Success:', res);
        this.delegate = res.delegate;
        this.url = res.url;
      } else {
        console.error(`initMagicLink Failed [Attempt #${this.retries}]`, res);
        setTimeout(() => {
          this.initMagicLink(url);
        }, 1000);
      }
    });
  }
}
